import { Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import graphql from 'babel-plugin-relay/macro';
import { RelayEnvironmentProvider, useQueryLoader } from 'react-relay/hooks';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import locale from 'date-fns/locale/lt';

import Splash from 'components/Splash';
import Theme from 'components/Theme';
import Router from 'components/Router';

import { environment } from 'lib/relay';
import { BASE } from 'const';
import { AppQuery as AppQueryType } from '__generated__/AppQuery.graphql';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

const AppQuery = graphql`
  query AppQuery {
    ...Main_data
  }
`;

function App() {
  const [preloadedQuery, load] = useQueryLoader<AppQueryType>(AppQuery);

  useEffect(() => {
    load({});
  }, [load]);

  return (
    <Suspense fallback={<Splash />}>
      {preloadedQuery && <Router preloadedQuery={preloadedQuery} />}
    </Suspense>
  );
}

function AppRoot() {
  return (
    <Theme>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
        <RelayEnvironmentProvider environment={environment}>
          <BrowserRouter basename={BASE}>
            <App />
          </BrowserRouter>
        </RelayEnvironmentProvider>
      </LocalizationProvider>
    </Theme>
  );
}

export default AppRoot;
